import React from 'react';
import { ClipboardList } from 'lucide-react';

// Lets staff link an Assign to Job to the open part request it fulfills (value: line id, 'none', or null).
export const RequestMatchChoice = ({ matches, value, onChange }) => {
  if (!matches?.length) return null;
  return (
    <div className="space-y-2 rounded-lg border border-sky-200 bg-sky-50 p-3" data-testid="request-match-choice">
      <p className="flex items-center gap-2 text-sm font-medium text-sky-900">
        <ClipboardList className="h-4 w-4" />
        {matches.length === 1 ? 'This job has an open part request for this item' : 'This job has several open part requests for this item. Choose one.'}
      </p>
      {matches.map((m) => (
        <label key={m.part_request_item_id} className="flex cursor-pointer items-start gap-2 text-sm"
          data-testid={`request-match-option-${m.part_request_item_id}`}>
          <input type="radio" name="request-match" className="mt-1" checked={value === m.part_request_item_id}
            onChange={() => onChange(m.part_request_item_id)} />
          <span>
            <span className="font-medium">Request #{m.part_request_id.slice(0, 8)}</span>
            <span className="text-muted-foreground"> · {m.status} · {m.outstanding} outstanding
              {m.quantity_fulfilled > 0 ? ` (${m.quantity_fulfilled} already assigned)` : ''}
              {m.requested_by ? ` · by ${m.requested_by}` : ''}</span>
          </span>
        </label>
      ))}
      <label className="flex cursor-pointer items-center gap-2 text-sm" data-testid="request-match-option-none">
        <input type="radio" name="request-match" checked={value === 'none'} onChange={() => onChange('none')} />
        <span>Not for a part request</span>
      </label>
      <p className="text-xs text-sky-800">
        Linking releases the request's reservation and records the parts as allocated to the job; they come off on-hand when marked used.
      </p>
    </div>
  );
};

export default RequestMatchChoice;
